import React from 'react';
import { Link } from 'react-router-dom';

export const Header = (props: any) => {
  const handleOpenCloseLeft = props.handleOpenCloseLeft

  return (
    <React.Fragment>
      {/* Mobile Navigation */}
      <div className="metaportal_fn_mobnav">
        <div className="mob_top">
          <div className="trigger_logo" style={{display: "inline-block"}}>
            <div className="trigger" style={{display: "inline-block",verticalAlign:"middle"}} onClick={handleOpenCloseLeft}>
              <span></span>
            </div>
            <div className="logo" style={{display: "inline-block",verticalAlign:"middle"}}>
              <Link to="/"><img src="/img/logo.png" style={{verticalAlign:"middle"}} alt="" width="250" height="75" /></Link>
            </div>
          </div>
          <div className="logo">
            {/* <Link to="/"><img src="/img/logoUMN.png" alt="" width="58" height="108" /></Link> */}
            <Link to="/"><img src="/img/logo4MN.png" alt="" width="250" height="75" /></Link>
          </div>
        </div>
      </div>
      {/* !Mobile Navigation */}

      {/* Header */}
      <header id="header">
        <div className="header">
          <div className="header_in">

            <div className="trigger_logo">
              <div className="trigger" onClick={handleOpenCloseLeft}>
                <span></span>
              </div>
              <div className="logo">
                <Link to="/"><img src="/img/logo.png" alt="" width="300" height="90" /></Link>
              </div>
            </div>

            <div className="logo">
              {/* <img src="/img/logo4MN.png" alt="" width="58" height="108" /> */}
              <img src="/img/logo4MN.png" alt=""  width="370" height="90" />
            </div>

          </div>
        </div>
      </header>
      {/* !Header */}
    </React.Fragment>
  )


}





